export default __webpack_public_path__ + "static/media/liban.ddb174b0.svg";